<template>
  <div class="d-flex align-items-center flex-grow-1">
    <!--begin::Avatar-->
    <div class="symbol symbol-45px me-5">
      <a href="" class="symbol symbol-50px">
        <img
            class="symbol-label"
            :src="$getImage(user?.avatar)"
            alt=""
            v-if="user?.avatar"
        />
        <img
            src="@/assets/images/MotTruyen_LogoApp1.png"
            alt=""
            v-else
        />
      </a>
    </div>
    <!--end::Avatar-->

    <!--begin::Info-->
    <div class="d-flex flex-column">
      <a href="#" class="text-gray-900 text-hover-primary fs-6 fw-bolder">{{ user?.name ?? 'Không xác định' }}</a>
      <span class="text-gray-400 fw-bold">#{{ user?.refCode }}</span>
      <span class="text-gray-400 fw-bold">{{ user?.email }}</span>
    </div>
    <!--end::Info-->
  </div>
</template>

<script>
export default {
  name: 'UserCard',
  props: {
    user: {
      type: Object,
      required: true,
    },
  },
};
</script>
